import React, {useMemo} from 'react';
import SpaceUsageFilterForm from "./SpaceUsageFilterForm";
import useUrlQueryParams from "../../../hooks/useUrlQueryParams";

const SpaceUsageFilterWithQueryParams = (props) => {
  const { onChange, defaultStartDate, defaultEndDate } = props;
  // Working with an uncontrolled component here, so we need to pass the initial value in filterByOptions
  const {overageInvoiceNumber} = useUrlQueryParams();
  const filterByOptions = useMemo(() => {
    return [
      {name: "bookingNumber", label: "Booking Number", value: "", numberField: true, inputProps: { inputMode: "numeric" }},
      {name: "overageInvoiceNumber", label: "Overage Invoice Number", value: overageInvoiceNumber || "", numberField: true, inputProps: { inputMode: "numeric" }}
    ];
  }, [overageInvoiceNumber]);

  return (
    <SpaceUsageFilterForm
      defaultEndDate={defaultEndDate}
      defaultStartDate={defaultStartDate}
      filterByOptions={filterByOptions}
      onChange={onChange}
    />
  );
};

export default SpaceUsageFilterWithQueryParams;